import classnames from 'classnames';
import React, { Component } from 'react';
import CircularProgressbar from 'react-circular-progressbar';

import {
  VIDEO_DOWNLOAD_CLICK,
  VIDEO_DOWNLOAD_COMPLETED,
} from 'constants/events';
import * as analytics from 'utilities/analytics';
import { isMobile } from 'utilities/device';
import DownloadProgress from 'utilities/download-progress';

import { CALL_OUT_PURPLE, WHITE } from '../../../constants/colors';

import Tooltip from 'components/ui-components/tooltip';

import './styles.less';

class DownloadButton extends Component {
  state = { downloading: false, percent: 0 };
  render() {
    const {
      currentUserIsOwner,
      downloadEnabled,
      downloadName,
      downloadUrl,
      onDownloadUnverifiedClicked,
      ownerVerified,
      videoIsTeamShared,
    } = this.props;
    const { downloading, percent } = this.state;

    const downloadable =
      !isMobile && (downloadEnabled || currentUserIsOwner || videoIsTeamShared);

    if (!downloadable) {
      return null;
    }

    const classNames = classnames(
      [
        'download-button',
        'tooltip-target', // add tooltip hover manually, b/c we mess around with classes
      ],
      {
        downloading,
        preparing: !downloadUrl,
      }
    );

    if (ownerVerified && downloadUrl != null) {
      return (
        <a
          className={classNames}
          href={downloadUrl}
          target="_blank"
          rel="noopener noreferrer"
          download={downloadName}
          onClick={this.startDownload}
        >
          {downloading && (
            <CircularProgressbar
              percentage={percent}
              strokeWidth={10}
              styles={{
                path: {
                  stroke: CALL_OUT_PURPLE,
                  strokeLinecap: 'round',
                },
                trail: {
                  stroke: WHITE,
                },
              }}
            />
          )}
          <Tooltip>
            {!downloading
              ? 'Download'
              : "Please don't close this tab while your video downloads"}
          </Tooltip>
        </a>
      );
    }

    return (
      <a
        className={classNames}
        onClick={ownerVerified ? null : onDownloadUnverifiedClicked}
      >
        <Tooltip stickyOnHover={true}>
          {ownerVerified && (
            <>
              <div>Polishing pixels.</div>
              <div>Your download&apos;s coming up!</div>
            </>
          )}
          {!ownerVerified && currentUserIsOwner && (
            <>
              <div>You must verify your email to download.</div>
              <a
                href="#"
                onClick={this.props.postVerifyEmail}
                className="tooltip-cta"
              >
                Resend Verification Email
              </a>
            </>
          )}
          {!ownerVerified && !currentUserIsOwner && (
            <>
              <div>Video owner must verify their email</div>
              <div>before this video is downloadable</div>
            </>
          )}
        </Tooltip>
      </a>
    );
  }

  startDownload = e => {
    e.preventDefault();

    if (this.state.downloading) {
      return false;
    }

    const {
      downloadName,
      downloadUrl,
      currentUserIsOwner,
      videoId,
      videoIsTeamShared,
    } = this.props;
    const onProgress = percent => this.setState({ percent });
    const onError = () => this.resetDownloadState();
    const onComplete = () => {
      this.trackDownload();
      this.resetDownloadState();
      download.save();
    };
    const download = new DownloadProgress(onProgress, onComplete, onError);

    download.fetch(downloadUrl, downloadName);
    this.setState({ downloading: true });

    analytics.track(VIDEO_DOWNLOAD_CLICK, {
      video_id: videoId,
      is_video_owner: currentUserIsOwner,
      video_is_team_shared: videoIsTeamShared,
    });
  };

  resetDownloadState = () => this.setState({ downloading: false, percent: 0 });

  trackDownload = () => {
    const { currentUserIsOwner, videoId, videoIsTeamShared } = this.props;

    analytics.track(VIDEO_DOWNLOAD_COMPLETED, {
      video_id: videoId,
      is_video_owner: currentUserIsOwner,
      video_is_team_shared: videoIsTeamShared,
    });
  };
}

export default DownloadButton;
